import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@azim-crm/icons";
import { EmptyState } from "../EmptyState/EmptyState.js";
import styles from "./Timeline.module.css";
/**
 * Timeline / ActivityFeed genérico do Azim CRM.
 * Consolida a linha do tempo de eventos (contas, oportunidades, e futuramente
 * outros históricos) num único componente — o vocabulário de evento e o
 * ícone por tipo são injetados pelo consumidor.
 *
 * Restyle Onda D (D5): ícones circulares ("bolha") sobre uma linha vertical,
 * no lugar dos cartões da versão anterior.
 */
export function Timeline({ events, iconByType, ariaLabel, emptyMessage = "Sem eventos registrados", scrollable = false, highlightFirst = false, }) {
    if (events.length === 0) {
        return _jsx(EmptyState, { title: emptyMessage });
    }
    const listCls = [styles.list, scrollable ? styles.scrollable : ""].filter(Boolean).join(" ");
    return (_jsx("ol", { role: "list", "aria-label": ariaLabel, className: listCls, children: events.map((event, index) => {
            const highlighted = highlightFirst && index === 0;
            const iconWrapCls = [styles.iconWrap, highlighted ? styles.iconWrapHighlighted : ""]
                .filter(Boolean)
                .join(" ");
            return (_jsxs("li", { role: "listitem", className: styles.item, children: [_jsx("span", { className: iconWrapCls, "aria-hidden": "true", children: _jsx(Icon, { name: iconByType[event.type] ?? "note", size: 14 }) }), _jsxs("div", { className: styles.body, children: [_jsx("p", { className: styles.title, children: event.title }), _jsxs("p", { className: styles.meta, children: [event.timestamp, event.actor ? ` · ${event.actor}` : ""] }), event.quote && _jsxs("p", { className: styles.quote, children: ["\u201C", event.quote, "\u201D"] })] })] }, event.id));
        }) }));
}
//# sourceMappingURL=Timeline.js.map